import request from '@/utils/request'

/**
 * 分类网站列表
 */
export function categorySiteList() {
  return request({
    url: '/client/nav/category/site/list',
    method: 'get'
  })
}

/**
 * 分类列表
 */
export function categoryList() {
  return request({
    url: '/client/nav/category/list',
    method: 'get'
  })
}

/**
 * 用户分类网站列表
 */
export function categorySiteUserList() {
  return request({
    url: '/client/nav/user/category/site/list',
    method: 'get'
  })
}

/**
 * 最新收录列表
 */
export function listLatestCollect() {
  return request({
    url: '/client/nav/latest/collect/list',
    method: 'get'
  })
}
